import React, { useState } from 'react';
import { ICONS } from '../constants';
import Button from './ui/Button';
import { useTranslation } from '../hooks/useTranslation';
import InviteModal from './InviteModal';

interface InviteButtonProps {
  userRole: string;
}

const InviteButton: React.FC<InviteButtonProps> = ({ userRole }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  // Coordinator cannot create invites
  if (userRole === 'Coordinator') {
    return null;
  }

  return (
    <>
      <Button
        onClick={() => setShowModal(true)}
        variant="secondary"
        className="flex items-center space-x-0 sm:space-x-2 !px-3 sm:!px-4 !py-2"
        title={t('invite.createInvite')}
      >
        <ICONS.ExternalLink className="w-4 h-4 sm:w-5 sm:h-5" />
        <span className="hidden sm:inline">{t('invite.buttonText')}</span>
      </Button>

      {showModal && (
        <InviteModal
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default InviteButton;

